import { DaoModel } from './daoModel';

export class Currency extends DaoModel {
  constructor(guid, symbol, symbolPosition) {
    super(guid);
    this.symbol = symbol;
    this.symbolPosition = symbolPosition;
  }

  static toInstance(props = {}) {
    return new Currency(props.guid, props.symbol, props.symbol_position);
  }

  serialize() {
    return {
      ...super.serialize(),
      symbol: this.symbol,
      symbol_position: this.symbolPosition
    };
  }

  hasLeftPosition() {
    return this.symbolPosition === 'left';
  }

  hasRightPosition() {
    return this.symbolPosition === 'right';
  }
}
